// Secondary text on the dashboard (labels, empty states). It reads at 4.5:1 or more (WCAG AA) on
// both of the dashboard's backgrounds: the page (#111827) and the cards (#1f2937).
export const SECONDARY_TEXT = '#9ca3af';

// An empty chart dims its icon only: dimming the whole block took its text below 4.5:1.
export const EMPTY_STATE_ICON_OPACITY = 0.6;
